import React from 'react';
import { Recurrence } from '@teetsh/app/src/containers/Pricing/types';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';
import { ButtonDisplay } from 'components/Buttons/ButtonDisplay';

interface Props {
  onChange: (v: Recurrence) => void;
  value: Recurrence;
}

export default function Toggle(props: Props) {
  const { onChange, value } = props;
  const { t } = useTranslation(['userSettings']);
  return (
    <div tw="flex justify-center">
      <div tw="gap-x-4 flex">
        <ButtonDisplay
          size="lg"
          active={value === 'MONTHLY'}
          css={
            value === 'MONTHLY'
              ? tw`bg-white text-brand-intense`
              : tw`text-reverse-moderate hover:text-brand-intense`
          }
          onClick={() => onChange('MONTHLY')}
        >
          {t('userSettings:pricing.perMonth')}
        </ButtonDisplay>
        <ButtonDisplay
          size="lg"
          active={value === 'YEARLY'}
          css={
            value === 'YEARLY'
              ? tw`bg-white text-brand-intense`
              : tw`text-reverse-moderate hover:text-brand-intense`
          }
          onClick={() => onChange('YEARLY')}
        >
          {t('userSettings:pricing.perYear')}
          <span tw="italic">&nbsp;(-20%)</span>
        </ButtonDisplay>
      </div>
    </div>
  );
}
